import { useEffect, useState } from 'react';
import { getWebCatalog, getWebCatalogByBranch } from '../api/catalogApi';

// optional: webSettings ichidan businessId ni olishga harakat qilamiz
function deriveBusinessIdFromWebSettings(ws) {
    // Agar backend web-settings javobida businessId bo'lsa, shu yerdan qaytaring.
    // Sizning struktura farq qilsa, moslang:
    return ws?.businessId || ws?.business?.id || null;
}

export function useCatalog({ businessId, branchId, webSettings }) {
    const [catalog, setCatalog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setErr] = useState(null);

    useEffect(() => {
        const controller = new AbortController();

        const effectiveBusinessId = businessId || deriveBusinessIdFromWebSettings(webSettings);

        // Hech biri yo'q bo'lsa, branchId bo'lsa fallback endpointga uramiz
        const canUseBusiness = !!effectiveBusinessId;
        const canUseBranch = !effectiveBusinessId && !!branchId;

        if (!canUseBusiness && !canUseBranch) return;

        (async () => {
            try {
                setLoading(true);
                setErr(null);

                let data;
                if (canUseBusiness) {
                    data = await getWebCatalog(effectiveBusinessId, { signal: controller.signal });
                } else {
                    data = await getWebCatalogByBranch(branchId, { signal: controller.signal });
                }
                setCatalog(data);
            } catch (e) {
                setErr(e);
                setCatalog(null);
            } finally {
                setLoading(false);
            }
        })();

        return () => controller.abort();
    }, [businessId, branchId, webSettings]);

    return { catalog, loading, error };
}
